import { UserTicket } from "../entities/userTicket";
import { OnboardingRepository } from "../repositories/OnboardingRepository";

export class SendNewTicket {
	constructor(private repository: OnboardingRepository) {}
	execute(data: UserTicket): Promise<void> {
		return this.repository.sendNewTicket(data);
	}
}
